import React from "react";
import { Row, Col } from "react-bootstrap";
import storage from "../../../../Storage";
import socket from "../../../../Socket";
import { decode, encode, wait, isEmail, sendNotfication } from "../../../../Helper";
import ReactTooltip from "react-tooltip";
import C from "../../../../Constant";

class Parent extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            firstUserName: storage.getKey('name'),
            firstEmail: (storage.getKey('email') !== 'false') ? storage.getKey('email') : '',
            token: storage.getKey('token'),
            email: (storage.getKey('email') !== 'false') ? storage.getKey('email') : '',
            username: storage.getKey('name'),
            loadingEmail: false,
            loadingUsername: false,
            loadingPrivacy: false,
            loading2Fa: false,
            checkbox: false,
            checkbox2: false
        };
    }

    componentDidMount() {
        this._isMounted = true;
        socket.on(C.EDIT_ACCOUNT, data => this.updateProfile(decode(data)));
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    updateProfile(data) {
        if (this._isMounted) {
            this.setState({ loadingUsername: false, loadingEmail: false });
            if (data.status) {
                storage.setKey('name', this.state.username);
                storage.setKey('email', this.state.email);
                sendNotfication('Your Account Setting was Updated !', 'success', 'top-center');
                window.location.reload();
            }
            else {
                return sendNotfication(data.error, 'success', 'top-center');
            }
        }
    }

    save(input) {
        if (this._isMounted) {
            let { token, email, username, firstUserName, firstEmail } = this.state;

            if (input === 'email') {
                if (email === firstEmail) {
                    return sendNotfication('Please Enter New Phone Number !', 'info', 'top-center');
                }

                if (!email) {
                    document.getElementById('email').classList.add('border-danger');
                    return;
                }

                if (email.trim() === "") {
                    document.getElementById('email').classList.add('border-danger');
                    return;
                }

                // if(!isEmail(email))
                // {
                //     document.getElementById('email').classList.add('border-danger');
                //     return;
                // }

                this.setState({ loadingEmail: true });

                wait(100).then(() => {
                    socket.emit(C.EDIT_ACCOUNT, encode({
                        token: token,
                        email: email
                    }));
                })
            }

            if (input === 'username') {
                if (username === firstUserName) {
                    return sendNotfication('Please Enter New Username !', 'info', 'top-center');
                }

                if (!username) {
                    document.getElementById('username').classList.add('border-danger');
                    return;
                }

                if (username.trim() === "") {
                    document.getElementById('username').classList.add('border-danger');
                    return;
                }

                this.setState({ loadingUsername: true });

                wait(500).then(() => {
                    socket.emit(C.EDIT_ACCOUNT, encode({
                        token: token,
                        username: username
                    }));
                })
            }
        }
    }

    handleCheckBox = (e) => {
        this.setState({ checkbox: true, loadingPrivacy: true });
        wait(1200).then(() => {
            this.setState({ loadingPrivacy: false, checkbox: false });
            return sendNotfication('This feature can\'t be active in your account !', 'info', 'top-center');
        })
    }

    render() {
        return (
            <>
                <ReactTooltip />
                <div className="auth-form">
                    <div className="mb-4">
                        <label className="text-white opacity-70 mb-2 small font-weight-bold">Phone Number</label>
                        <div className="auth-input-wrapper mb-0">
                            <i className="mdi mdi-cellphone" />
                            <input
                                type="text"
                                id="email"
                                autoComplete={'off'}
                                className="form-control auth-input-custom"
                                placeholder={'Enter New Phone Number'}
                                value={this.state.email}
                                required={true}
                                onChange={e => this.setState({ email: e.target.value })}
                                style={{ paddingRight: '100px' }}
                            />
                            <button
                                onClick={e => this.save('email')}
                                type="button"
                                className="position-absolute border-0 bg-transparent text-success font-weight-bold"
                                style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', zIndex: 5, fontSize: '0.85rem' }}
                            >
                                {this.state.loadingEmail ?
                                    <div className="spinner-border spinner-border-sm" role="status" />
                                    : 'SAVE'
                                }
                            </button>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="text-white opacity-70 mb-2 small font-weight-bold">Username</label>
                        <div className="auth-input-wrapper mb-0">
                            <i className="mdi mdi-account-outline" />
                            <input
                                type="text"
                                id="username"
                                autoComplete={'off'}
                                className="form-control auth-input-custom"
                                value={this.state.username}
                                required={true}
                                onChange={e => this.setState({ username: e.target.value })}
                                style={{ paddingRight: '100px' }}
                            />
                            <button
                                onClick={e => this.save('username')}
                                type="button"
                                className="position-absolute border-0 bg-transparent text-success font-weight-bold"
                                style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', zIndex: 5, fontSize: '0.85rem' }}
                            >
                                {this.state.loadingUsername ?
                                    <div className="spinner-border spinner-border-sm" role="status" />
                                    : 'SAVE'
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Parent;